export default __webpack_public_path__ + "static/Real-Estate-kpi-ea81266a85358732564cb518a3f2e8f0.svg";